'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Scope = /*#__PURE__*/function () {
  function Scope(block, executor) {
    (0, _classCallCheck2["default"])(this, Scope);
    this.block = block;
    this.type = block ? block.type : null; //legacy
    this.executor = executor;
    this.entity = executor.entity;
  }
  return (0, _createClass2["default"])(Scope, [{
    key: "callReturn",
    value: function callReturn() {
      return undefined;
    }
  }, {
    key: "getParam",
    value: function getParam(index) {
      var param = this.block.params[index];
      if (param instanceof Entry.Block) {
        var newScope = new Entry.Scope(param, this.executor);
        var result = newScope.run(this.entity, true);
        return result;
      } else {
        return this.filterReservedKeywords(param);
      }
    }

    // 클래스 레벨에서 한 번만 생성
  }, {
    key: "filterReservedKeywords",
    value: function filterReservedKeywords(param) {
      return Scope._reservedKeywords.has(param) ? '' : param;
    }
  }, {
    key: "getParams",
    value: function getParams() {
      var _this = this;
      return this.block.params.map(function (param) {
        if (param instanceof Entry.Block) {
          var fieldBlock = param;
          var newScope = new Entry.Scope(fieldBlock, _this.executor);
          return newScope.run(_this.entity, true);
        } else {
          return _this.filterReservedKeywords(param);
        }
      });
    }
  }, {
    key: "_setBlockState",
    value: function _setBlockState(fieldBlock, valueState) {
      var newScope = new Entry.Scope(fieldBlock, this.executor);
      var result = Entry.block[fieldBlock.type].func.call(newScope, this.entity, newScope);
      var blockId = fieldBlock.data.id;
      if (result instanceof Promise) {
        if (valueState[blockId].state === 'pending') {
          throw new Entry.Utils.AsyncError();
        }
        valueState[blockId].state = 'pending';
        result.then(function (value) {
          valueState[blockId].state = 'complete';
          valueState[blockId].value = value;
        });
      } else {
        valueState[blockId].state = 'complete';
        valueState[blockId].value = result;
      }
    }
  }, {
    key: "_setChildBlockState",
    value: function _setChildBlockState(fieldBlocks, currentBlockId) {
      var _this2 = this;
      var valueState = this.executor.valueState || {};
      var hasPending = false;
      if (valueState[currentBlockId].state === 'wait') {
        fieldBlocks.forEach(function (fieldBlock) {
          var blockId = fieldBlock.data.id;
          valueState[blockId] = valueState[blockId] || {
            state: 'wait'
          };
          if (valueState[blockId].state === 'wait') {
            _this2._setBlockState(fieldBlock, valueState);
          }
          hasPending = hasPending || valueState[blockId].state === 'pending';
        });
      }
      if (hasPending && valueState[currentBlockId].state === 'wait') {
        valueState[currentBlockId].state = 'pending';
        throw new Entry.Utils.AsyncError();
      }
    }
  }, {
    key: "getValues",
    value: function getValues(keys, scope) {
      var _this3 = this;
      return keys.map(function (key) {
        return _this3.values[_this3._getParamIndex(key, scope)];
      });
    }
  }, {
    key: "getValue",
    value: function getValue(key, scope) {
      return this.values[this._getParamIndex(key, scope)];
    }

    /**
     * 일반 getValue 값을 가져오기 전,
     * 현 Scope 상태에서의 executor.valueMap 을 세팅한다.
     * 이 로직은 Promise.all[] 과 유사하며, 모든 값이 준비될 때까지 Scope 를 멈춘다.
     * @param{Array} fieldBlocks getValue 에 의한 호출의 경우 1, getValues 의 경우 1 이상
     */
  }, {
    key: "_setExecutorValueMap",
    value: function _setExecutorValueMap(fieldBlocks) {
      var _this4 = this;
      var executorValueMap = this.executor.valueMap;
      fieldBlocks.forEach(function (block) {
        var blockId = block.data.id;
        if (executorValueMap[blockId] === 'isPending') {
          throw new Entry.Utils.AsyncError();
        } else if (executorValueMap[blockId] && executorValueMap[blockId].name === 'IncompatibleError') {
          throw executorValueMap[blockId];
        } else if (executorValueMap[blockId] !== undefined) {
          return executorValueMap[blockId];
        }
        var newScope = new Entry.Scope(block, _this4.executor);
        var result = Entry.block[block.type].func.call(newScope, _this4.entity, newScope);
        if (result instanceof Promise) {
          executorValueMap[blockId] = 'isPending';
          result.then(function (value) {
            executorValueMap[blockId] = value;
          });
          throw new Entry.Utils.AsyncError();
        } else {
          executorValueMap[blockId] = result;
        }
      });
    }
  }, {
    key: "getStringValue",
    value: function getStringValue(key, scope) {
      return String(this.getValue(key, scope));
    }
  }, {
    key: "getNumberValue",
    value: function getNumberValue(key, scope) {
      return parseFloat(this.getValue(key, scope)) || 0;
    }
  }, {
    key: "getBooleanValue",
    value: function getBooleanValue(key, scope) {
      var value = this.getValue(key, scope);
      if (value === undefined) {
        return false;
      }
      value = Number(value);
      return isNaN(value) ? true : value; // handle "0" or "0.00"
    }
  }, {
    key: "getField",
    value: function getField(key) {
      return this.filterReservedKeywords(this.block.params[this._getParamIndex(key)]);
    }
  }, {
    key: "getStringField",
    value: function getStringField(key) {
      return String(this.getField(key));
    }
  }, {
    key: "getNumberField",
    value: function getNumberField(key) {
      return Number(this.getField(key));
    }
  }, {
    key: "getStatement",
    value: function getStatement(key, scope) {
      return this.executor.stepInto(this.block.statements[this._getStatementIndex(key, scope)]);
    }
  }, {
    key: "_getParamIndex",
    value: function _getParamIndex(key) {
      if (!this._schema) {
        this._schema = Entry.block[this.type];
      }
      return this._schema.paramsKeyMap[key];
    }
  }, {
    key: "_getStatementIndex",
    value: function _getStatementIndex(key) {
      if (!this._schema) {
        this._schema = Entry.block[this.type];
      }
      return this._schema.statementsKeyMap[key];
    }
  }, {
    key: "die",
    value: function die() {
      this.block = null;
      return Entry.STATIC.BREAK;
    }
  }, {
    key: "run",
    value: function run(entity, isValue) {
      var _this5 = this;
      var schema = this.block.getSchema();
      if (this.isCondition) {
        return schema.func.call(this, entity, this);
      }
      var values = this.getParams();
      var isPromise = values.some(function (value) {
        return value instanceof Promise;
      });
      if (!schema.func) {
        return;
      }
      if (!isPromise) {
        this.values = values;
        return schema.func.call(this, entity, this);
      } else {
        return Promise.all(values).then(/*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(values) {
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!(Entry.engine.state !== 'stop' && _this5.block)) {
                    _context.next = 2;
                    break;
                  }
                  _this5.values = values;
                  _context.next = 1;
                  return schema.func.call(_this5, entity, _this5);
                case 1:
                  return _context.abrupt("return", _context.sent);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }
  }]);
}();
(0, _defineProperty2["default"])(Scope, "_reservedKeywords", new Set(['__proto__']));
Entry.Scope = Scope;